import type { DocumentPickerAsset } from 'expo-document-picker'; // File Type in native

function getFileData(file: File | DocumentPickerAsset) {
  return file;
}

export { getFileData };
